import { Component } from '@angular/core';
import { AssetsComponent } from '../assets/assets.component';
import { NgClass, NgSwitch, NgSwitchCase } from '@angular/common';
import { KalakarAccountComponent } from '../kalakar-account/kalakar-account.component';

@Component({
  selector: 'app-kalakar-account-parent',
  imports: [AssetsComponent,KalakarAccountComponent,NgClass,NgSwitch,NgSwitchCase],
  templateUrl: './kalakar-account-parent.component.html',
  styleUrl: './kalakar-account-parent.component.css'
})
export class KalakarAccountParentComponent {
  activeTab: 'account' | 'assets' = 'account';
}
